$(document).ready(function(){
$('.letest_slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 400,
 prevArrow: '<div class="slide-arrow-prev"><svg width="28" height="35" viewBox="0 0 28 47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.5132 3.00002L4 23.5132L24.5132 44.0264" stroke="#0A0A0A" stroke-width="5" stroke-linecap="round"/></svg></div>',
  nextArrow: '<div class="slide-arrow-next"><svg width="27" height="35" viewBox="0 0 27 47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.50612 44.0263L23.0193 23.5132L2.50612 3.00001" stroke="#0A0A0A" stroke-width="5" stroke-linecap="round"/></svg></div>',
  slidesToShow: 2,
  slidesToScroll: 2,
  autoplay: true,
  centerMode: false,
  adaptiveHeight: false,
  responsive: [  
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows:true,
        centerMode: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows:true,
        centerMode: false
      }
    }
  ]
}); 
}); 




////
$(document).ready(function () {
	$(".letest_slider1").slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
        adaptiveHeight: false,
        infinite: false,
		autoplay: false,
        responsive: [  
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows:true,
        centerMode: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows:true,
        centerMode: false
      }
    }
  ]
	});
  
	$(".prev-btn").click(function () {
		$(".slick-list").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".slick-list").slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$(".slick-list").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});
});


